module.exports = __webpack_public_path__ + "static/020.thumb-a3a7f0601dcb6049a06b4cc20aa27ad2.jpg";